import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d189a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "nav",
  class: "navbar navbar-expand-md bg-dark",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "container-fluid container-lg d-flex flex-row justify-content-end justify-content-md-between bg-transparent" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler border-primary my-2 me-3",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("em", { class: "bi bi-list text-primary d-flex fs-3" })
], -1))
const _hoisted_4 = {
  class: "flex-row align-items-center collapse navbar-collapse text-center bg-transparent m-3",
  id: "navbarNav"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-block" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-primary m-0" }, "PLENTYFULL")
], -1))
const _hoisted_6 = { class: "w-100 navbar-nav justify-content-center" }
const _hoisted_7 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_8 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_9 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_10 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_11 = {
  key: 0,
  class: "nav-item px-2 px-lg-4"
}
const _hoisted_12 = {
  key: 1,
  class: "nav-item px-2 px-lg-4"
}
const _hoisted_13 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_14 = {
  key: 2,
  class: "nav-item px-2 px-lg-4"
}
const _hoisted_15 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_16 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_17 = { class: "nav-item px-2 px-lg-4" }
const _hoisted_18 = { class: "nav-item d-block d-md-none px-2 px-lg-4" }
const _hoisted_19 = { class: "nav-item d-block d-md-none px-2 px-lg-4" }
const _hoisted_20 = {
  key: 1,
  class: "dropdown d-none d-md-block"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "bi bi-person-circle h5" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "dropdown-menu dropdown-menu-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.role.length > 0)
        ? (_openBlock(), _createBlock(_component_Notifications, {
            key: 0,
            class: "d-block d-md-none",
            filterByRead: _ctx.filterByRead,
            isOpen: _ctx.dropdownIsOpen,
            onUpdateFilter: _cache[0] || (_cache[0] = (bool) => (this.filterByRead = bool))
          }, null, 8, ["filterByRead", "isOpen"]))
        : _createCommentVNode("", true),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          (_ctx.role.length === 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/' }]),
                    to: "/"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Home")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/about' }]),
                    to: "/about"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("About")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("li", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/register' }]),
                    to: "/register"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Register")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/login' }]),
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Login")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.role === 'Donor' || _ctx.role === 'Charity')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.role === 'Donor')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                            _createVNode(_component_router_link, {
                              class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/donate' }]),
                              to: "/donate"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Donate")
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]))
                        : (_openBlock(), _createElementBlock("li", _hoisted_12, [
                            _createVNode(_component_router_link, {
                              class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/receive' }]),
                              to: "/receive"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Receive")
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ])),
                      _createElementVNode("li", _hoisted_13, [
                        _createVNode(_component_router_link, {
                          class: "nav-link",
                          to: "/find"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Find")
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.role === 'Donor')
                        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                            _createVNode(_component_router_link, {
                              class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/transactions' }]),
                              to: "/transactions"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Transactions")
                              ]),
                              _: 1
                            }, 8, ["class"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/statistics' }]),
                          to: "/statistics"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Statistics")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("li", _hoisted_16, [
                        _createVNode(_component_router_link, {
                          class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/statistics' }]),
                          to: "/statistics"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Statistics")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _createElementVNode("li", _hoisted_17, [
                        _createVNode(_component_router_link, {
                          class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/registry' }]),
                          to: "/registry"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Registry")
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ])
                    ], 64)),
                _createElementVNode("li", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    class: _normalizeClass(["nav-link", { active: _ctx.$route.path === '/profile' }]),
                    to: "/profile"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Profile")
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("li", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: "/"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Log Out")
                    ]),
                    _: 1
                  })
                ])
              ], 64))
        ]),
        (_ctx.role.length > 0)
          ? (_openBlock(), _createBlock(_component_Notifications, {
              key: 0,
              class: "d-none d-md-block",
              filterByRead: _ctx.filterByRead,
              isOpen: _ctx.dropdownIsOpen,
              onUpdateFilter: _cache[1] || (_cache[1] = (bool) => (this.filterByRead = bool))
            }, null, 8, ["filterByRead", "isOpen"]))
          : _createCommentVNode("", true),
        (_ctx.role.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn dropdown-toggle", _ctx.$route.path === '/profile' ? 'text-primary' : 'text-white']),
                type: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false"
              }, _hoisted_22, 2),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_router_link, {
                  class: "dropdown-item",
                  to: "/profile"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Profile")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  class: "dropdown-item",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log Out")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}